module.exports = __webpack_public_path__ + "static/media/app2.c25ee083.png";